import React from 'react';
import PropTypes from 'prop-types';
import { FaTwitter, FaInstagram } from 'react-icons/fa';
import { IoLogoTiktok } from 'react-icons/io5';
import { BiCalendarEvent } from 'react-icons/bi';
import { BsBag } from 'react-icons/bs';
import './Profile.css';

const Profile = ({
  image,
  twitter,
  instagram,
  tiktok,
  name,
  username,
  bio,
  dob,
  occupation,
}) => {
  return (
    <section className="section profilesection">
      <div className="profilesection__user">
        <div className="flex flex-ai-c">
          <div className="image mr-4">
            <img src={image} alt="User" />
          </div>
          <div>
            <div className="flex profilesection-stats">
              <div className="flex flex-ai-c mr-1 profilesection__stat">
                <p className="stats__count">1200</p>
                <p>Haes</p>
              </div>
              <div className="flex flex-ai-c mr-1 profilesection__stat">
                <p className="stats__count">450</p>
                <p>Peers</p>
              </div>
              <div className="flex flex-ai-c profilesection__stat">
                <p className="stats__count">200</p>
                <p>Followers</p>
              </div>
            </div>
            <div className="flex flex-ai-c mb-1 profilesection__name">
              <h3 className="mr">{name}</h3>
              <p className="username">{username}</p>
            </div>
            <div className="flex profilesection__bio-data">
              <div className="flex flex-ai-c mb mr">
                <BiCalendarEvent className="icon icon--xs" />
                <p>{dob}</p>
              </div>
              <div className="flex flex-ai-c mb">
                <BsBag className="icon icon--xs" />
                <p>{occupation}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex mb-1 profilesection__name2">
        <h3 className="mr">{name}</h3>
        <p className="username">{username}</p>
      </div>
      <div className="flex mb-1 profilesection__bio-data2">
        <div className="flex flex-ai-c mb mr-1">
          <BiCalendarEvent className="icon icon--xs" />
          <p>{dob}</p>
        </div>
        <div className="flex flex-ai-c mb">
          <BsBag className="icon icon--xs" />
          <p>{occupation}</p>
        </div>
      </div>
      <div className="mb-1">
        <button type="button" className="btn btn--primary">
          Edit Profile
        </button>
      </div>
      <div className="mb-1 profilesection__bio">
        <p className="title">Bio</p>
        <p>{bio}</p>
      </div>
      <div className="flex profilesection__socials">
        <div className="flex flex-ai-c profilesection__social">
          <FaTwitter className="icon icon--xs" color="#019cb1" />
          <p>{twitter}</p>
        </div>
        <div className="flex flex-ai-c profilesection__social">
          <FaInstagram className="icon icon--xs" color="#019cb1" />
          <p>{instagram}</p>
        </div>
        <div className="flex flex-ai-c profilesection__social">
          <IoLogoTiktok className="icon icon--xs" color="#019cb1" />
          <p>{tiktok}</p>
        </div>
      </div>
    </section>
  );
};

Profile.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  username: PropTypes.string,
  bio: PropTypes.string,
  twitter: PropTypes.string,
  instagram: PropTypes.string,
  tiktok: PropTypes.string,
  dob: PropTypes.string,
  occupation: PropTypes.string,
};

Profile.defaultProps = {
  image:
    'https://i0.wp.com/www.repol.copl.ulaval.ca/wp-content/uploads/2019/01/default-user-icon.jpg',
  name: 'Tolulope Victoria',
  username: '#simplytolz',
  bio: 'A senior product designer at Haelo| Former product designer at @worldcitizen',
  twitter: '@simplytolz',
  instagram: '@simplytolz',
  tiktok: '@simplytolz',
  dob: 'Born 23 May',
  occupation: 'Product Designer',
};
export default Profile;
